
import { USERMESSAGE, USERLOGINADDRESS, UserBuyingCities } from '../type'

let initState = {

  user: {},
  loinAddress: {}

};

export const AutReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {

    case USERMESSAGE:
      return {
        ...state,
        user: payload
      }
    case USERLOGINADDRESS:

      return {
        ...state,
        loinAddress: payload
      }

    case UserBuyingCities:
      return {
        ...state,
        usebuycities: payload
      }

    default:
      return state;
  }
};

